import React from 'react';
import { motion } from 'framer-motion';
import { CABINS } from '../data/cabins';
import { FeaturedCabinCard } from './FeaturedCabinCard';
import { CabinCard } from './CabinCard';
import { MiniCabinCard } from './MiniCabinCard';
interface CabinsSectionProps {
  onSelectCabin: (id: string) => void;
}
export function CabinsSection({
  onSelectCabin
}: CabinsSectionProps) {
  const featured = CABINS.find(c => c.id === 'saman')!;
  const gridCabins = CABINS.filter(c => c.layout === 'grid');
  const secondary = CABINS.find(c => c.id === 'pomarosa')!;
  const miniCabins = CABINS.filter(c => c.layout === 'mini');
  return <section id="cabanas" className="bg-night px-6 sm:px-8 lg:px-12 py-24" data-id="element-97" data-mp="2xeppv0nwwb0">
      <div className="max-w-7xl mx-auto" data-id="element-98" data-mp="7z40ranvx9z3">
        <motion.div initial={{
        opacity: 0,
        y: 35
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-99" data-mp="7vzqbvjtthzz">
          <span className="inline-block text-[0.67rem] font-semibold tracking-[0.3em] uppercase text-gold mb-5" data-id="element-100" data-mp="rjczqmyxwe3t">
            Nuestras Cabañas
          </span>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.15] text-white" data-id="element-101" data-mp="nfncq1xwy4kw">
            9 formas de <em className="italic text-gold" data-id="element-102" data-mp="djtuc1xijgv7">vivir el refugio</em>
          </h2>
          <p className="text-sm leading-[1.8] text-white/45 max-w-xl mx-auto mt-4" data-id="element-103" data-mp="8k7j1y18wap1">
            Cada cabaña tiene su propia personalidad. Encuentra la tuya.
          </p>
        </motion.div>

        <FeaturedCabinCard cabin={featured} variant="primary" onSelect={onSelectCabin} data-id="element-104" data-mp="3ro34uf353h2" />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-5" data-id="element-105" data-mp="3vv72gqzdl4v7">
          {gridCabins.map((cabin, i) => <CabinCard key={cabin.id} cabin={cabin} onSelect={onSelectCabin} delay={i * 0.1} data-id="element-106" data-mp="3lyuabxjhaz2k" data-mpi={i} />)}
        </div>

        <FeaturedCabinCard cabin={secondary} variant="secondary" onSelect={onSelectCabin} data-id="element-107" data-mp="3h12a8g8ok6na" />

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5" data-id="element-108" data-mp="37c5ec5ofr40x">
          {miniCabins.map(cabin => <MiniCabinCard key={cabin.id} cabin={cabin} onSelect={onSelectCabin} data-id="element-109" data-mp="3ccjd0x45d1ma" />)}
        </div>
      </div>
    </section>;
}